import { render, staticRenderFns } from "./Comments.vue?vue&type=template&id=3c50f8f2&scoped=true&"
import script from "./Comments.vue?vue&type=script&lang=js&"
export * from "./Comments.vue?vue&type=script&lang=js&"
import style0 from "./Comments.vue?vue&type=style&index=0&id=3c50f8f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c50f8f2",
  null
  
)

export default component.exports
import {QExpansionItem,QIcon,QBtn,QItem} from 'quasar'
component.options.components = Object.assign({QExpansionItem,QIcon,QBtn,QItem}, component.options.components || {})
